import { Row } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Dayjs } from "dayjs";
import { useCallback } from "react";

type CalendarHeaderProps = {
  value: Dayjs;
  onChange: (value: Dayjs) => void;
};

export const CalendarHeader = ({ value, onChange }: CalendarHeaderProps) => {
  const FORMAT = "MMM YYYY";

  const prevMonth = useCallback(() => {
    const prev = value.clone().subtract(1, "M");

    onChange(prev);
  }, [onChange, value]);

  const nextMonth = useCallback(() => {
    const next = value.clone().add(1, "M");

    onChange(next);
  }, [onChange, value]);

  return (
    <Row className="pt-2 justify-space-between align-center px-2 mb-3">
      <LeftOutlined onClick={prevMonth} />
      <span className="text-md w-500">{value.format(FORMAT)}</span>
      <RightOutlined onClick={nextMonth} />
    </Row>
  );
};
